import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-confirm-signup',
  templateUrl: './confirm-signup.component.html',
})
export class ConfirmSignupComponent implements OnInit {
  email = '';
  code = '';
  error: string | null = null;
  loading = false;

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}

  private returnUrl: string | null = null;

  ngOnInit(): void {
    this.email = this.route.snapshot.queryParamMap.get('email') ?? '';
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
  }

  async onSubmit(): Promise<void> {
    this.error = null;
    this.loading = true;
    try {
      await this.auth.confirmSignUp(this.email, this.code);
      if (this.returnUrl) {
        await this.router.navigateByUrl(this.returnUrl);
      } else {
        await this.router.navigate(['/select-plan']);
      }
    } catch (err: unknown) {
      this.error = err instanceof Error ? err.message : 'Confirmation failed. Please try again.';
    } finally {
      this.loading = false;
    }
  }
}
